import { LookupType } from "./lookups";

export const PIRLookup: Array<LookupType> = [
    { value: 0.105, key: "10.5%" },
    { value: 0.175, key: "17.5%" },
    { value: 0.28, key: "28%" }
];
